export const MUMU_INCOMPLETE_STACK_HINT_ZH = 'MuMu模拟器可能堆栈不全，可能无法上报 crash';
export const MUMU_INCOMPLETE_STACK_HINT_EN = 'MuMu emulator may have an incomplete stack and may fail to report crashes';

const MUMU_X86_CPU = new Set(['x86', 'x86_64']);

export function shouldShowMumuIncompleteStackHint(vmType, vmDeviceBrand, cpuType) {
  const cpu = String(cpuType || '').trim().toLowerCase();
  return Number(vmType) === 2
    && vmDeviceBrand === 'MuMu'
    && MUMU_X86_CPU.has(cpu);
}
